export enum FeedbackStatus {
  NEW = 'new',
  READ = 'read',
}
